import { Link } from 'react-router-dom';
import { useMerchantMap } from '@/hooks';

interface MerchantCellProps {
  merchantId: string;
}

/**
 * Tabellenzelle die Merchant-Name + ID anzeigt.
 * Name ist klickbar und navigiert zur Merchant-Detail-Seite.
 * Resolved den Namen intern ueber useMerchantMap().
 * Fallback: zeigt nur die ID wenn kein Name gefunden.
 */
export function MerchantCell({ merchantId }: MerchantCellProps) {
  const { resolveMerchantName } = useMerchantMap();
  const name = resolveMerchantName(merchantId);
  const hasName = name !== merchantId;

  return (
    <div>
      {hasName && (
        <Link
          to={`/merchants/${merchantId}`}
          className="font-medium text-primary hover:underline"
          onClick={(e) => e.stopPropagation()}
        >
          {name}
        </Link>
      )}
      <div className="text-xs text-muted-foreground font-mono">{merchantId}</div>
    </div>
  );
}
